





























































































































// vue
import { defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useBlueprintHook } from '@/vue3/hooks/blueprintHook';

// primevue
import InputText from 'primevue/inputtext';

// babylon
import { useBabylonEngine } from '@/vue3/components/link-model-editor/babylonEngine';

export default defineComponent({
    components: {
        InputText,
    },
    props: {
        modelPath: {
            type: String,
            default: '',
        },
        value: {
            type: Object,
            default: () => {},
        },
    },
    setup(props: any) {
        // hooks
        const { createSvg } = useBlueprintHook();
        const store = useStore();

        // refs
        const canvas = ref<HTMLCanvasElement>();
        const svg = ref<SVGSVGElement | null>();

        // reactive
        const model = ref();

        // lifecycle
        onMounted(async () => {
            svg.value = createSvg(
                {
                    geometry: props.value.geometry,
                    type: 'Feature',
                },
                {
                    strokeWidth: 20,
                    stroke: '#fff',
                    width: 2000,
                    height: 2000,
                    padding: 200,
                    color: '#3057e1',
                },
            );

            if (svg.value) {
                // drawGrid(2000, 2000, 1, svg.value);
            }

            if (canvas.value) {
                const { init, scene, generateTexture, drawSvgOnTexture } =
                    useBabylonEngine(canvas.value);
                init();
                if (scene.value) {
                    const plane = BABYLON.Mesh.CreatePlane(
                        'plane',
                        10,
                        scene.value,
                    );
                    plane.rotation.x += Math.PI / 2;

                    const texture = generateTexture(2048 * 4);

                    const blueprintMaterial = new BABYLON.StandardMaterial(
                        'blueprint',
                        scene.value,
                    );
                    blueprintMaterial.diffuseTexture = texture;
                    blueprintMaterial.backFaceCulling = false;

                    await drawSvgOnTexture(
                        new XMLSerializer().serializeToString(
                            svg.value as Node,
                        ),
                        texture,
                    );

                    plane.material = blueprintMaterial;

                    // import model
                    BABYLON.SceneLoader.ImportMesh(
                        '',
                        `${store.state.apiUrl}/${props.modelPath}`,
                        '',
                        scene.value,
                        function (meshes) {
                            meshes.forEach((mesh) => {
                                mesh.position = new BABYLON.Vector3(
                                    props.value.positionX,
                                    props.value.positionY,
                                    props.value.positionZ,
                                );
                                mesh.rotation = new BABYLON.Vector3(
                                    props.value.rotationX,
                                    props.value.rotationY,
                                    props.value.rotationZ,
                                );
                                mesh.scaling = new BABYLON.Vector3(
                                    props.value.scale,
                                    props.value.scale,
                                    props.value.scale,
                                );
                                model.value = mesh;
                            });
                        },
                    );
                }
            }
        });

        watch(
            () => props.value.positionX,
            (value) => {
                if (model.value) {
                    model.value.position = new BABYLON.Vector3(
                        value,
                        props.value.positionY,
                        props.value.positionZ,
                    );
                }
            },
        );

        watch(
            () => props.value.positionY,
            (value) => {
                if (model.value) {
                    model.value.position = new BABYLON.Vector3(
                        props.value.positionX,
                        value,
                        props.value.positionZ,
                    );
                }
            },
        );

        watch(
            () => props.value.positionZ,
            (value) => {
                if (model.value) {
                    model.value.position = new BABYLON.Vector3(
                        props.value.positionX,
                        props.value.positionY,
                        value,
                    );
                }
            },
        );

        watch(
            () => props.value.rotationX,
            (value) => {
                if (model.value) {
                    model.value.rotation = new BABYLON.Vector3(
                        value * (Math.PI / 180),
                        props.value.rotationY * (Math.PI / 180),
                        props.value.rotationZ * (Math.PI / 180),
                    );
                }
            },
        );

        watch(
            () => props.value.rotationY,
            (value) => {
                if (model.value) {
                    model.value.rotation = new BABYLON.Vector3(
                        props.value.rotationX * (Math.PI / 180),
                        value * (Math.PI / 180),
                        props.value.rotationZ * (Math.PI / 180),
                    );
                }
            },
        );

        watch(
            () => props.value.rotationZ,
            (value) => {
                if (model.value) {
                    model.value.rotation = new BABYLON.Vector3(
                        props.value.rotationX * (Math.PI / 180),
                        props.value.rotationY * (Math.PI / 180),
                        value * (Math.PI / 180),
                    );
                }
            },
        );

        watch(
            () => props.value.scale,
            () => {
                if (model.value) {
                    model.value.scaling = new BABYLON.Vector3(
                        props.value.scale,
                        props.value.scale,
                        props.value.scale,
                    );
                }
            },
        );

        return {
            canvas,
            svg,
        };
    },
});
